// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuLabel_root__3TkmG","clickedWithMouse":"MenuLabel_clickedWithMouse__31c0u","isOpen":"MenuLabel_isOpen__8HQrj"};